import {gql} from "@apollo/client";
import {ChannelType} from "./getChannel";

export const GET_ALL_CHANNEL = gql`
    query ChannelQuery{
        getAllChannels{
            id
            channelName
            companyName
            companyAddress
            contactName
            contactPhone
            email
            taxRate
            taxId
            status
            remark
        }
    }
`;

export interface allChannelResponse {
    getAllChannels: ChannelType[];
}

export const SEARCH_CHANNELS_BY_NAME = gql`
    query SearchChannelsByName($keyword: String!) {
        searchChannelsByName(keyword: $keyword) {
            id
            channelName
            companyName
        }
    }
`;

export interface SearchChannelsByNameResponse {
    searchChannelsByName: Pick<ChannelType, 'id' | 'channelName' | 'companyName'>[];
}

export const GET_ALL_CHANNEL_LITE = gql`
    query ChannelLiteQuery {
        getAllChannelsLite {
            id
            channelName
        }
    }
`;

export interface ChannelLiteType {
    id: string;
    channelName: string;
}

export interface allChannelLiteResponse {
    getAllChannelsLite: ChannelLiteType[];
}